import React from 'react';
import {
  Embed,
  Header,
} from 'semantic-ui-react';

const Custom = ({ user }) => {
  return (
    <React.Fragment>
      <Header as='h2' inverted>Custom Commands</Header>
      <p>
        Custom Commands is currently in Beta release. While the functionality feels stable and there should not be any big changes in how it works, there may still be bugs
        that are being worked out. The command set available to Custom Commands will continue to change over time, as new functionality is added, allowing for an even greater
        customization experience.
      </p>
      <p>
        Custom Commands allows you to create custom commands to be used on your channel. These can either be used directly in chat, or tied to functionality with the
        Donations or Channel Points system.
      </p>
      <Header as='h3' inverted>Editor</Header>
      <p>
        The Custom Command editor uses a simple click, drag, and drop interface. The menu at the top of the editor has functionality categorized by what it will effect,
        and clicking on a menu item will create a puzzle piece like element in the editor. You can drag and drop these pieces to create the functionality of your command.
      </p>
      <Embed
        url='/images/support-custom-command-drag-and-drop.webm'
        active={true}
      />
      <br />
      <p>
        All commands will have a basic outline that command blocks need to be added to - anything not attached to the main block will be ignore and not executed.
      </p>
      <p>
        Within the basic outline, you can enter the command name, and a description of the command (which will show up on the command help page).
      </p>
      <Embed
        url='/images/support-custom-command-interface.webm'
        active={true}
      />
      <br />
      <Header as='h3' inverted>User Input</Header>
      <p>
        You can create commands that take additional parameters for user input. This is done from the <strong>Logic</strong> menu, and allows you to define positional
        input parameters. Positional input, means that parameters are expected to exist in a specific order. Each input parameter will expect a single input to exist
        that corresponds with an input definition, unless you set the input type to <strong>rest</strong>, which uses the remaining input from the command as a single
        input. <strong>Rest</strong> parameters can only exist once in a command definition, and need to exist as the last defintion for input.
      </p>
      <p>
        For example, the global command <strong>!repeat</strong> uses the syntax: <em>!repeat [count] [command]</em>. In this command definition, the <strong>count</strong>
        is a positional input, expecting an integer as input. The <strong>command</strong> is of type rest, and will take the remaining content of the command line and
        use that for determining the command and inputs that need to be repeated.
      </p>
      <p>
        Another example of this functionality is the <strong>!stat</strong> command, which uses the syntax: <em>!stat [stat name] [value]</em>. For both of these inputs,
        we are using positional inputs, since the <strong>stat name</strong> will only be a single word. If you were doing something similar with, for example, the name
        of an active item, then you would want to use a <strong>rest</strong> parameter type, as item names are often multiple words, and would not be picked up fully
        as a <strong>positional</strong> parameter.
      </p>
      <p>
        The following video shows creating a command that uses a positional parameter to specify the duration that a command should use when applying the Burn effect to
        all enemy monsters in the current room:
      </p>
      <Embed
        url='/images/support-custom-command-burn-example.webm'
        active={true}
      />
      <br />
      <p>
        The next video shows using a rest paramter to allow entering in the player to transform to. If we were to use a positional parameter, then input such as
        <strong>!transform tainted lilith</strong> would only pick up the input "tainted", and not the full input of "tainted lilith".
      </p>
      <Embed
        url='/images/support-custom-command-transform-example.webm'
        active={true}
      />
      <br />
    </React.Fragment>
  )
};

export default Custom;
